import { GET_GOOGLE_TOKEN, GET_GOOGLE_AUTH_URL, DELETE_GOOGLE_TOKEN } from '../mutation-types'

const state = {
  token: null,
  authUrl: null,
  code: null
}

const mutations = {
  [GET_GOOGLE_AUTH_URL] (state, url) {
    state.authUrl = url
  },
  [GET_GOOGLE_TOKEN] (state, token) {
    state.token = token
  },
  [DELETE_GOOGLE_TOKEN] (state, token) {
    state.token = null
  }
}

export default { state, mutations }



// WEBPACK FOOTER //
// ./src/vuex/modules/google.js